import { useAuth } from "@/auth/auth";
import useSWR from "swr";

export function usePlans() {
  const auth = useAuth();

  const { data, error } = useSWR("/plans", () => auth.client.GET("/plans"));

  return {
    plans: data?.data ?? [],
    error,
  };
} 